//PrimeReact
import { Dialog } from "primereact/dialog"

//ReferralEntityUsers
import ReferralEntityUserAdd from "./ReferralEntityUserAdd"
import ReferralEntityUserEdit from "./ReferralEntityUserEdit"

export default function ReferralEntityUserDialog({
  userProfile,
  partnerOrganizationId,
  showDialog,
  onHideDialog,
  onChanged,
}) {
  if (!showDialog) {
    return null
  } else {
    const isCreate = !userProfile

    return (
      <Dialog
        header={isCreate ? "Create new user profile" : "Manage user profile"}
        visible={showDialog}
        onHide={() => {
          onHideDialog()
        }}
        style={{ width: "1100px", height: "900px" }}
      >
        {isCreate ? (
          <ReferralEntityUserAdd
            onCancel={onHideDialog}
            onSubmit={onChanged || onHideDialog}
            partnerOrganizationId={partnerOrganizationId}
          />
        ) : (
          <ReferralEntityUserEdit
            onCancel={onHideDialog}
            onSubmit={onChanged || onHideDialog}
            partnerOrganizationId={partnerOrganizationId}
            userId={userProfile.staff_id}
          />
        )}
      </Dialog>
    )
  }
}
